import React from 'react';
import { useTranslation } from 'react-i18next';

// ui
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
// components
import DeleteModal from 'commons/components/DeleteModal';
import ItemList from 'screens/Fruits/components/ItemList';
import Filters from 'screens/Fruits/components/Filters';
import TableActionMenu from 'commons/components/TableActionMenu';
import FruitForm from './FruitForm';

function FruitsComponent(props) {
  const { t } = useTranslation();
  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={props.classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={props.classes.marginTop}>
            {t('Species')}
          </Typography>
        </Grid>
        <Filters
          classes={props.classes}
          filter={props.filter}
          onFilterChange={props.onFilterChange}
        />
        <Grid container item>
          <Grid item xs={12} sm={4} md={3}>
            <TableActionMenu
              menuItems={[
                {
                  label: t('Export'),
                  listItems: [
                    {
                      label: t('Excel file'),
                      onClick: props.actions.exportFruits,
                      params: [props.fruitList],
                    },
                  ],
                },
              ]}
            />
          </Grid>
        </Grid>
        <ItemList
          classes={props.classes}
          objects={props.objects}
          toggleEdit={props.toggleEdit}
          toggleDelete={props.toggleDelete}
          fruitList={props.fruitList}
          anchorEl={props.anchorEl}
          handleClick={props.handleClick}
          handleClose={props.handleClose}
        />
      </Grid>
      <FruitForm
        isOpen={props.formIsOpen}
        toggleForm={props.toggleForm}
        changeControls={props.changeControls}
        onChange={props.actions.changeControls}
        controls={props.formControls}
        edit={props.edit}
        submit={props.submit}
        invalidControls={props.invalidControls}
      />
      <DeleteModal
        isOpen={props.deleteIsOpen}
        toggleForm={props.closeForm}
        submit={props.submitDelete}
        buttonId="delete-fruit"
      />
      <Fab
        color="primary"
        aria-label="add"
        className={props.classes.fab}
        onClick={props.toggleForm}>
        <AddIcon />
      </Fab>
    </Container>
  );
}

export default FruitsComponent;
